/* Vinanest editorial: collection pages + search results (snippets/vne-collection-grid.liquid, snippets/vne-pcard.liquid,
   sections/vne-search.liquid). Rides on vinanest-editorial.js (window.VNE, 'vne:ready', 'vne:cart'); runs before it (both
   deferred, this one earlier in the page).
   - Add buttons: every card adds its own exact variant (data-vne-cadd = variant id → VNE.add). A tap on a card whose exact
     variant is already in the order opens the order instead of adding a second box. A 227g box in the order never blocks
     the 100g box of the same nest.
   - Photos: nest boxes (data-vne-card = copy key, + data-vne-big for 227g) belong to the main script, exactly as on the home
     grid (desktop pointer scrub, phone swipe). Products without copy carry data-vne-shots: this script gives them the
     same .vne-cg markup and behaviour (photos load shortly before they are needed). A card only ever has one owner.
   - Search: nest boxes get the Vietnamese copy, the clean packshot (600px file) and the main script's photos straight from
     #vne-data as soon as the page is parsed, before any photo has loaded. The no-results list follows the home order.
   - Sort: on touch screens choosing an option reloads the list at once (the native picker commits on Done). With a mouse
     the pick also reloads; with the keyboard nothing happens until the visible "Xếp" button is pressed (WCAG 3.2.2).
     Without JS the button does it. */
(function () {
  'use strict';
  var W = window, D = document, H = D.documentElement;
  function qa(s, el) { return Array.prototype.slice.call((el || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isEn() { return H.getAttribute('data-vne-lang') === 'en'; }
  function V() { return W.VNE || null; }
  function track(n, d) { var v = V(); if (v && v.track) v.track(n, d); }
  function setBi(el, vi, en) {
    if (!el) return;
    var a = el.querySelector('.vi'), b = el.querySelector('.en');
    if (a && b) { a.textContent = vi; b.textContent = en || vi; } else el.innerHTML = '<span class="vi">' + esc(vi) + '</span><span class="en">' + esc(en || vi) + '</span>';
  }
  function label(el, vi, en) { el.setAttribute('data-vi-label', vi); el.setAttribute('data-en-label', en || vi); el.setAttribute('aria-label', isEn() ? (en || vi) : vi); }
  var FINE = !!(W.matchMedia && W.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var SIZES = '(min-width: 960px) 380px, 144px';

  /* ---------- the store data (#vne-data is already in the page when this deferred script runs) ---------- */
  var DATA = null, BYVID = {}, ORDER = {};
  function readData() {
    if (DATA) return DATA;
    try { var el = D.getElementById('vne-data'); DATA = el ? JSON.parse(el.textContent) : null; } catch (e) { DATA = null; }
    ((DATA && DATA.products) || []).forEach(function (p, i) {
      BYVID[p.vid] = { p: p, big: false }; ORDER[p.vid] = i;
      if (p.large) { BYVID[p.large.vid] = { p: p, big: true }; ORDER[p.large.vid] = 100 + i; }
    });
    return DATA;
  }
  function money(c) {
    var v = V();
    if (v && v.money) return v.money(c);
    var x = Math.round(+c || 0) / 100;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (DATA && DATA.currency) || 'USD' }).format(x); } catch (e) { return '$' + x.toFixed(2); }
  }
  function mImg(u) { u = String(u || ''); return /-m\.jpg(\?|$)/.test(u) ? u : u.replace(/\.jpg(\?|$)/, '-m.jpg$1'); }

  /* ---------- photos for products without copy (data-vne-shots) ---------- */
  function build(card, noLoad) {
    if (!card || !card.hasAttribute('data-vne-shots')) return null;
    if (card._g) { if (!noLoad) load(card._g); return card._g; }
    var box = card.querySelector('.vne-card-img'), shots = [];
    if (!box || box.querySelector('.vne-cg')) return null;
    try { shots = JSON.parse(card.getAttribute('data-vne-shots') || '[]'); } catch (e) { shots = []; }
    if (!shots.length) return null;
    var wrap = D.createElement('span');
    wrap.className = 'vne-cg';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = shots.map(function (s) { return '<img data-src="' + esc(s[0]) + '" alt="" decoding="async">'; }).join('') +
      '<span class="vne-cg-cap" hidden></span><span class="vne-cg-ticks"><i class="vne-on"></i>' + new Array(shots.length + 1).join('<i></i>') + '</span>';
    box.appendChild(wrap);
    card._g = { n: shots.length + 1, i: 0, wrap: wrap, imgs: qa('img', wrap), ticks: qa('i', wrap), cap: wrap.querySelector('.vne-cg-cap'),
      caps: shots.map(function (s) { return [s[1] || '', s[2] || s[1] || '']; }), key: card.getAttribute('data-vne-card'), seen: {}, own: 1 };
    if (!noLoad) load(card._g);
    return card._g;
  }
  function load(g) {
    if (!g.imgs || g.loaded) return;
    g.loaded = true;
    g.imgs.forEach(function (im) { if (!im.getAttribute('src')) im.setAttribute('src', im.getAttribute('data-src')); });
  }
  function show(card, i, dir) {
    var g = card._g;
    if (!g || !g.own || g.n < 2 || g.i === i) return;
    g.i = i;
    if (dir) g.wrap.setAttribute('data-dir', dir); else g.wrap.removeAttribute('data-dir');
    g.imgs.forEach(function (im, k) { im.classList.toggle('vne-on', k === i - 1); });
    g.ticks.forEach(function (t, k) { t.classList.toggle('vne-on', k === i); });
    g.cap.hidden = !i;
    if (i) {
      g.cap.innerHTML = '<span class="vi">' + esc(g.caps[i - 1][0]) + '</span><span class="en">' + esc(g.caps[i - 1][1]) + '</span>';
      if (!g.seen[i]) { g.seen[i] = 1; track('card_frame', { id: g.key, i: i }); }
    }
  }
  function ownCard(t) { var c = t && t.closest && t.closest('[data-vne-shots]'); return c && c.matches('[data-vne-card]') ? c : null; }
  function wireGallery(grid) {
    if (!grid) return;
    var cards = qa('[data-vne-card][data-vne-shots]', grid);
    if (!cards.length) return;
    if (FINE) {
      if ('IntersectionObserver' in W) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { build(en.target); io.unobserve(en.target); } }); }, { rootMargin: '200px 0px' });
        cards.forEach(function (c) { io.observe(c); });
      }
      grid.addEventListener('pointerover', function (e) { if (e.pointerType === 'mouse') build(ownCard(e.target)); });
      grid.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var box = e.target.closest && e.target.closest('.vne-card-img'), card = box && ownCard(box), g = card && build(card);
        if (!g || g.n < 2) return;
        var r = box.getBoundingClientRect();
        show(card, Math.min(g.n - 1, Math.max(0, Math.floor((e.clientX - r.left) / r.width * g.n))));
      });
      grid.addEventListener('pointerout', function (e) {
        var box = e.target.closest && e.target.closest('.vne-card-img');
        if (!box || (e.relatedTarget && box.contains(e.relatedTarget))) return;
        var card = ownCard(box);
        if (card) show(card, 0);
      });
    } else {
      /* touch: ticks from the start (nothing loaded), photos load on the first touch; a sideways swipe steps one photo */
      cards.forEach(function (c) { build(c, true); });
      var sw = null;
      grid.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        var box = e.target.closest && e.target.closest('.vne-card-img'), card = box && ownCard(box), g = card && build(card);
        sw = g && g.n > 1 ? { card: card, x: e.clientX, y: e.clientY } : null;
      }, { passive: true });
      grid.addEventListener('pointermove', function (e) {
        if (!sw) return;
        var dx = e.clientX - sw.x, dy = e.clientY - sw.y;
        if (Math.abs(dx) < 32 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        var g = sw.card._g;
        show(sw.card, Math.max(0, Math.min(g.n - 1, g.i + (dx < 0 ? 1 : -1))), dx < 0 ? 'next' : 'prev');
        sw = null;
      }, { passive: true });
      grid.addEventListener('pointerup', function () { sw = null; });
      grid.addEventListener('pointercancel', function () { sw = null; });
    }
  }
  /* a sideways swipe on any card photo (ours or the main script's) never also opens the product page */
  var downX = null, swipedAt = 0;
  D.addEventListener('pointerdown', function (e) { downX = e.pointerType !== 'mouse' && e.target.closest && e.target.closest('[data-vne-cgrid] .vne-card-img, [data-vne-sgrid] .vne-card-img') ? e.clientX : null; }, true);
  D.addEventListener('pointerup', function (e) { if (downX !== null && Math.abs(e.clientX - downX) > 24) swipedAt = Date.now(); downX = null; }, true);
  D.addEventListener('click', function (e) {
    if (Date.now() - swipedAt > 400) return;
    var a = e.target.closest && e.target.closest('[data-vne-cgrid] .vne-card-open, [data-vne-sgrid] .vne-card-open');
    if (a) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ---------- add buttons: the card's own variant ---------- */
  function paidHit(cart, vid) {
    return ((cart && cart.items) || []).some(function (it) { return String(it.variant_id) === String(vid) && it.final_line_price > 0 && !(it.properties && it.properties._addon); });
  }
  function paint(cart) {
    qa('[data-vne-cadd]').forEach(function (b) {
      var hit = paidHit(cart, b.getAttribute('data-vne-cadd'));
      var pr = b.querySelector('.vne-add-r b'), price = pr ? pr.textContent.trim() : '';
      var nv = b.getAttribute('data-nm-vi') || '', ne = b.getAttribute('data-nm-en') || nv;
      b.classList.toggle('vne-in', hit);
      if (hit) label(b, 'Đã thêm vào giỏ, xem đơn hàng: ' + nv, 'Added to cart, view your order: ' + ne);
      else label(b, 'Thêm vào giỏ: ' + nv + ', ' + price, 'Add to cart: ' + ne + ', ' + price);
    });
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-vne-cadd]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    var v = V(), vid = b.getAttribute('data-vne-cadd');
    if (!v || !v.add) { W.location.href = b.getAttribute('data-href') || '/'; return; }
    var hit = paidHit(v.cart(), vid), card = b.closest('[data-vne-card]');
    track('quick_add', { id: String(vid), key: card ? card.getAttribute('data-vne-card') : '', size: card && card.getAttribute('data-vne-big') === '1' ? 'large' : 'main', in_cart: hit, where: D.querySelector('[data-vne-search]') ? 'search' : 'collection' });
    if (hit) { v.openDrawer(); return; }
    v.add(+vid, 1);
  });
  D.addEventListener('vne:cart', function (e) { paint(e.detail); });

  /* ---------- sort ---------- */
  function wireSort() {
    var f = D.querySelector('[data-vne-sort]');
    if (!f) return;
    var sel = f.querySelector('select'), go = f.querySelector('[data-vne-sortgo]'), kb = false;
    if (!sel) return;
    if (!FINE && go) go.hidden = true;
    sel.addEventListener('keydown', function () { kb = true; });
    sel.addEventListener('pointerdown', function () { kb = false; });
    sel.addEventListener('change', function () {
      if (FINE && kb) return;   /* keyboard: wait for the "Xếp" button */
      track('sort', { by: sel.value });
      f.submit();
    });
    f.addEventListener('submit', function () { track('sort', { by: sel.value, button: 1 }); });
  }
  /* option text cannot hold the two language spans: follow the language switch */
  function relang() {
    var en = isEn();
    qa('option[data-vi]').forEach(function (o) { o.textContent = o.getAttribute(en ? 'data-en' : 'data-vi'); });
    var v = V(); if (v && v.cart) paint(v.cart());
  }

  /* ---------- search: Vietnamese copy + clean packshot + the main script's photos for nest boxes ---------- */
  function reveal(img, src, full) {
    if (!img || img.getAttribute('data-done')) return;
    img.onload = img.onerror = function () { img.setAttribute('data-done', '1'); };
    if (src && full) { img.setAttribute('sizes', SIZES); img.setAttribute('srcset', src + ' 600w, ' + full + ' 1000w'); }
    img.src = src || img.getAttribute('data-fallback') || '';
    if (!img.getAttribute('src')) img.setAttribute('data-done', '1');
  }
  function upgrade() {
    readData();
    qa('[data-vne-up]').forEach(function (card) {
      var hit = BYVID[card.getAttribute('data-vne-up')], img = card.querySelector('[data-vne-up-img]');
      if (!hit) { reveal(img); return; }
      var p = hit.p, L = hit.big && p.large ? p.large : null;
      var size = (L ? L.size : p.size) || ['', ''], bowls = (L ? L.bowls : p.bowls) || 0, price = L ? L.price : p.price;
      var name = p.name && p.name[0] ? p.name : null;
      if (name) setBi(card.querySelector('[data-vne-up-name]'), name[0], name[1]);
      var sh = card.querySelector('[data-vne-up-short]');
      if (sh && p.short && p.short[0]) { setBi(sh, p.short[0], p.short[1]); sh.hidden = false; }
      var tg = card.querySelector('[data-vne-up-tag]'), badge = L ? ['Hộp quà 227g', '227g gift box'] : p.badge;
      if (tg && badge && badge[0]) { setBi(tg, badge[0], badge[1]); tg.classList.remove('vne-tag-slot'); tg.removeAttribute('aria-hidden'); }
      var sz = card.querySelector('[data-vne-up-size]');
      if (sz && size[0]) {
        if (p.jars || !bowls) setBi(sz, size[0], size[1]);
        else setBi(sz, size[0] + ' · khoảng ' + bowls + ' chén', (size[1] || size[0]) + ' · about ' + bowls + ' bowls');
        sz.hidden = false;
      }
      var pe = card.querySelector('[data-vne-up-per]');
      if (pe && bowls && price) {
        var each = money(Math.round(price / bowls));
        setBi(pe, '≈ ' + each + (p.jars ? ' mỗi hũ' : ' mỗi chén'), '≈ ' + each + (p.jars ? ' per jar' : ' per bowl'));
        pe.hidden = false;
      }
      var b = card.querySelector('[data-vne-cadd]');
      if (b && name) {
        b.setAttribute('data-nm-vi', name[0] + (size[0] ? ', ' + size[0] : ''));
        b.setAttribute('data-nm-en', (name[1] || name[0]) + (size[1] || size[0] ? ', ' + (size[1] || size[0]) : ''));
      }
      /* hand the photos to the main script (same as the collection cards); it has not started yet */
      if (!card._g && p.key) {
        card.setAttribute('data-vne-card', p.key);
        if (L) card.setAttribute('data-vne-big', '1'); else card.removeAttribute('data-vne-big');
        card.removeAttribute('data-vne-shots');
      }
      var full = L ? (L.img || p.img) : p.img;
      reveal(img, full ? mImg(full) : '', full);
    });
    /* the no-results list: the home grid's order (100g boxes as on the home page, then the 227g gift boxes) */
    qa('[data-vne-homeorder]').forEach(function (grid) {
      var cards = qa('.vne-card', grid), rank = function (c) { var o = ORDER[c.getAttribute('data-vne-up')]; return o == null ? 1e4 : o; };
      cards.map(function (c, i) { return { c: c, r: rank(c), i: i }; }).sort(function (a, b) { return a.r - b.r || a.i - b.i; }).forEach(function (x) { grid.appendChild(x.c); });
    });
    paint(V() && V().cart ? V().cart() : null);
  }
  function searchPixel() {
    var s = D.querySelector('[data-vne-search]'), v = V();
    if (!s || !v) return;
    var q = s.getAttribute('data-q') || '';
    if (!q) return;
    var n = +(s.getAttribute('data-n') || 0);
    v.track('search', { q: q, results: n });
    if (v.pixel) v.pixel('Search', { search_string: q, content_category: 'product' });
  }

  function ready() {
    if (ready.done) return;
    ready.done = true;
    var v = V(); if (v && v.cart) paint(v.cart());
    searchPixel();
  }
  function start() {
    upgrade();
    qa('[data-vne-cgrid],[data-vne-sgrid]').forEach(wireGallery);
    wireSort();
    relang();
    if ('MutationObserver' in W) new MutationObserver(relang).observe(H, { attributes: true, attributeFilter: ['data-vne-lang'] });
    if (V()) ready(); else D.addEventListener('vne:ready', ready);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
